module.exports = __webpack_public_path__ + "img/2.565c4b00.png";